import { apiClient, handleApiRequest } from './client'
import type { DirectorGateSettings, GatePreviewResponse } from '@/types/teacher-request'

export interface OnBehalfTeacher {
  id: string
  last_name: string
  first_name: string
  teacher_code: string | null
  display_name: string
}

export const adminOnBehalfApi = {
  listTeachers: (q?: string) =>
    handleApiRequest<{ teachers: OnBehalfTeacher[] }>(
      apiClient.get('/api/v1/admin/on-behalf/teachers', { params: q ? { q } : undefined }),
    ),
  month: (teacherId: string, year: number, month: number) =>
    handleApiRequest<any>(
      apiClient.get(`/api/v1/admin/on-behalf/teachers/${teacherId}/timetable/month`, {
        params: { year, month },
      }),
    ),
  gateSettings: () =>
    handleApiRequest<DirectorGateSettings>(
      apiClient.get('/api/v1/admin/on-behalf/director-gate-settings'),
    ),
  gatePreview: (payload: {
    teacher_id: string
    entry_ids: string[]
    date?: string | null
    date_to?: string | null
    lessons?: { entry_id: string; date: string }[]
    absence_type?: string | null
  }, signal?: AbortSignal) =>
    handleApiRequest<GatePreviewResponse>(
      apiClient.post('/api/v1/admin/on-behalf/director-gate-preview', payload, { signal }),
    ),
  create: (payload: {
    teacher_id: string
    entry_ids: string[]
    date: string
    date_to?: string | null
    lessons?: { entry_id: string; date: string }[]
    absence_type?: string
    reason?: string
    message_to_substitutes?: string
    is_urgent?: boolean
  }) =>
    handleApiRequest<{
      request_id: string
      status: string
      lesson_count: number
      omitted?: { entry_id: string; date: string | null; subject_name: string | null }[]
    }>(
      apiClient.post('/api/v1/admin/on-behalf/requests', payload),
    ),
  submit: (requestId: string, skipGate: boolean) =>
    handleApiRequest<{
      request_id: string
      status: string
      success: boolean
      gate_skipped: boolean
      search_started: boolean
      director_parallel: boolean
      message: string
    }>(
      apiClient.post(`/api/v1/admin/on-behalf/requests/${requestId}/submit`, { skip_gate: skipGate }),
    ),
}
